/* ============================================================
   RAVUMI — media: wyciszenie wideo i ochrona przed kopiowaniem

   CZESC 1: DZWIEK
   Nagrania powstaly w plenerze i maja przypadkowy dzwiek.
   Wyciszamy je na stale i pilnujemy, zeby nikt (ani odtwarzacz
   Shopify, ani uzytkownik) tego nie odwrocil.

   CZESC 2: OCHRONA MEDIOW
   WAZNE, zeby nie bylo zludzen: kazdy plik, ktory przegladarka
   wyswietla, MUSI byc pobrany na komputer odwiedzajacego. Ponizsze
   zabezpieczenia utrudniaja kopiowanie przypadkowemu uzytkownikowi,
   ale nie zatrzymaja nikogo, kto umie otworzyc narzedzia
   deweloperskie. Realna ochrona zdjec to znak wodny.
   ============================================================ */

(function () {
  'use strict';

  /* ---------- CZESC 1: dzwiek ---------- */

  function wycisz(video) {
    if (!video || video.dataset.ravumiWyciszone === '1') return;

    video.muted = true;
    video.defaultMuted = true;
    video.volume = 0;
    video.setAttribute('muted', '');
    video.removeAttribute('controls');
    video.controls = false;

    // Gdyby cokolwiek probowalo wlaczyc dzwiek — natychmiast wyciszamy
    video.addEventListener('volumechange', function () {
      if (!video.muted || video.volume > 0) {
        video.muted = true;
        video.volume = 0;
      }
    });

    // Shopify potrafi dolozyc kontrolki po zaladowaniu odtwarzacza
    video.addEventListener('loadedmetadata', function () {
      video.controls = false;
      video.muted = true;
    });

    video.dataset.ravumiWyciszone = '1';
  }

  function wyciszWszystkie(gdzie) {
    var filmy = (gdzie || document).querySelectorAll('video');
    for (var i = 0; i < filmy.length; i++) wycisz(filmy[i]);
  }

  /* ---------- CZESC 2: utrudnienie kopiowania ---------- */

  function chron(el) {
    if (!el || el.dataset.ravumiChronione === '1') return;

    // Przeciaganie obrazka na pulpit
    el.setAttribute('draggable', 'false');
    el.addEventListener('dragstart', function (e) {
      e.preventDefault();
      return false;
    });

    // Menu pod prawym przyciskiem ("Zapisz obraz jako...")
    el.addEventListener('contextmenu', function (e) {
      e.preventDefault();
      return false;
    });

    el.dataset.ravumiChronione = '1';
  }

  function chronWszystkie(gdzie) {
    var media = (gdzie || document).querySelectorAll(
      'img, video, .card__media img, .product__media img'
    );
    for (var i = 0; i < media.length; i++) chron(media[i]);
  }

  /* ---------- Start ---------- */

  function start() {
    wyciszWszystkie();
    chronWszystkie();

    // Shopify dogrywa media w tle (galeria produktu, karty, modale),
    // wiec obserwujemy strone i obslugujemy takze nowe elementy.
    if (!window.MutationObserver) return;

    var obserwator = new MutationObserver(function (zmiany) {
      for (var i = 0; i < zmiany.length; i++) {
        var dodane = zmiany[i].addedNodes;
        for (var j = 0; j < dodane.length; j++) {
          var wezel = dodane[j];
          if (wezel.nodeType !== 1) continue;

          if (wezel.tagName === 'VIDEO') wycisz(wezel);
          if (wezel.tagName === 'IMG' || wezel.tagName === 'VIDEO') chron(wezel);

          if (wezel.querySelectorAll) {
            wyciszWszystkie(wezel);
            chronWszystkie(wezel);
          }
        }
      }
    });

    obserwator.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
